import buttons from "./buttons";

const error_codes = {
	/* --------------------------- BACK OFFICE RELATED -------------------------- */
	BACK_OFFICE_DEBTOR_GROUP_MEMBER_EXISTS:
		"Dieser Debitor ist bereits in dieser Debitorengruppe vorhanden.",

	// READ
	DADUP_ERR_1_NOT_FOUND: "Dadup nicht gefunden",

	/* ------------------------------ DADUP RELATED ----------------------------- */
	// CREATE
	DADUP_ERR_2_COULD_NOT_CREATE_DADUP:
		"Dadup kann nicht erstellt werden, bitte kontaktieren Sie uns.",

	DADUP_ERR_2_INVALID_DADUP_NAME: "Dieser Name ist für Ihr daDup-Konto nicht zulässig.",

	// DELETE
	DADUP_ERR_3_CANNOT_DELETE_WITH_BUCKETS:
		"Das Dadup-Konto kann nicht gelöscht werden, wenn noch Buckets auf dem Konto vorhanden sind.",

	DADUP_ERR_3_COULD_NOT_CREATE_BUCKET:
		"Der Bucket konnte nicht erstellt werden. Bitte wenden Sie sich an den Support.",

	DADUP_ERR_4_INVALID_BUCKET_NAME: "Dieser Name ist für Ihren Bucket nicht zulässig.",

	DADUP_ERR_5_BUCKET_NAME_ALREADY_EXISTS:
		"Es gibt bereits einen Bucket mit diesem Namen unter einem Ihrer daDup-Konten.",

	DADUP_ERR_8_COULD_NOT_READ_DADUP:
		"daDup konnte nicht gelesen werden. Bitte wenden Sie sich an den Support.",

	DADUP_ERR_9_HISTORY_USAGE_ERROR: "Der Verbrauch Ihrer Buckets konnte nicht gelesen werden.",

	DADUP_ERR_10_REQUEST_ACCESS_TOKEN_ERROR: "Ihre Anmeldedaten konnten nicht abgerufen werden.",

	DADUP_ERR_11_COULD_NOT_READ_BUCKET: "Ihre Bucket(s) konnten nicht gelesen werden.",

	// Update
	DADUP_ERR_12_COULD_NOT_UPDATE_DADUP: "daDup konnte nicht aktualisiert werden.",

	DADUP_ERR_13_CREDENTIALS_SAVED_ERROR: "Die gespeicherten Daten konnten nicht gespeichert werden.",

	DADUP_ERR_14_CANNOT_DELETE_WITH_BUCKETS:
		"Das daDup-Konto konnte nicht gelöscht werden, da noch Buckets vorhanden waren. Bitte löschen Sie zuerst alle Buckets.",

	DADUP_ERR_15_COULD_NOT_DELETE_DADUP:
		"Ihr daDup-Konto konnte nicht gelöscht werden. Bitte wenden Sie sich an den Support.",

	DADUP_ERR_16_COULD_NOT_UPDATE_BUCKET: "Ihr Bucket konnte nicht aktualisiert werden.",

	DADUP_ERR_17_COULD_NOT_DELETE_BUCKET:
		"Ihr Bucket konnte nicht gelöscht werden. Bitte wenden Sie sich an den Support.",

	//GENERAL / OTHER
	DADUP_ERR_18_COULD_NOT_SEND_DADUP_NOTIFICATION:
		"Die Benachrichtigung konnte nicht gesendet werden.",

	DADUP_ERR_19_COULD_NOT_HANDLE_DADUP_REQUEST:
		"Bei der Bearbeitung Ihrer daDup-Anfrage ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Support.",

	DADUP_ERR_20_COULD_NOT_HANDLE_BUCKET_REQUEST:
		"Bei der Bearbeitung Ihrer Bucket-Anfrage ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Support.",

	DADUP_ERR_21_COULD_NOT_UPDATE_DESCRIPTION:
		"Beim Aktualisieren der Beschreibung ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",

	/* ----------------------------- DEBTOR RELATED ----------------------------- */
	DEBTOR_ERR_1_PAID_SERVICES_DISABLED:
		"Für Ihr Konto sind keine kostenpflichtigen Dienste verfügbar. Wenn Sie glauben, dass dies nicht stimmt, wenden Sie sich bitte an unseren Kundenservice.",

	DEBTOR_ERR_2_DEBTOR_NOT_FOUND:
		"Der Schuldner wurde nicht gefunden. Sollte dies nicht der Fall sein, wenden Sie sich bitte an unseren Kundendienst, wenn das Problem weiterhin besteht.",

	DEBTOR_ERR_4_DEBTOR_DISABLED_IN_COUNTRY: "Registrierung aus Ihrem Land ist nicht zulässig.",
	DEBTOR_ERR_5_FREELOADER_DISABLED_IN_COUNTRY:
		"Registrierungen für private Nutzer sind aus Ihrem Land nicht zulässig.",

	DEBTOR_ERR_6_COMPANY_DETAILS_IDENTICAL_TO_TUXIS:
		"Ihre Umsatzsteuer-Identifikationsnummer und/oder Handelskammer-Nummer ist identisch mit der von Tuxis. Dies ist nicht zulässig.",

	DEBTOR_ERR_7_VIES_COUNTRY_CODE_NOT_MATCHING:
		"Die von Ihnen angegebene Umsatzsteuer-Identifikationsnummer stimmt nicht mit dem von Ihnen ausgewählten Land überein.",

	DEBTOR_ERR_8_VIES_INVALID_NUMBER:
		"Die von Ihnen angegebene Umsatzsteuer-Identifikationsnummer scheint falsch zu sein.",
	DEBTOR_ERR_9_VIES_COMMUNICATION_ERROR: `Beim VIES (VAT Information Exchange System) ist bei der Überprüfung der Mehrwertsteuernummer ein Fehler aufgetreten. Tuxis wurde benachrichtigt und wird sich mit Ihnen in Verbindung setzen, damit Ihr Konto noch erstellt werden kann. Sie können es jederzeit erneut versuchen, indem Sie auf "${buttons.sign_up}" klicken oder sich zu einem späteren Zeitpunkt erneut anmelden.`,
	DEBTOR_ERR_10_EMAIL_ADDRESS_NOT_EXISTS:
		"Die von Ihnen eingegebene Rechnungs-E-Mail-Adresse scheint nicht zu existieren.",
	/* ------------------------------- DNS RELATED ------------------------------ */
	DNS_ERR_1_DNS_TEMPLATE_NOT_FOUND:
		"DNS-Vorlage nicht gefunden, Bitte prüfen Sie die Existenz dieser Vorlage.",

	DNS_ERR_2_FAILED_TO_READ_FROM_POWERDNS:
		"Beim Abrufen der Informationen von PowerDNS ist ein Fehler aufgetreten. Bitte wenden Sie sich an unseren Kundendienst, wenn dieses Problem weiterhin besteht.",

	DNS_ERR_3_FAILED_TO_WRITE_TO_POWERDNS:
		"Beim Speichern in PowerDNS ist ein Fehler aufgetreten. Bitte überprüfen Sie die Werte oder wenden Sie sich an unseren Kundendienst, wenn das Problem weiterhin besteht.",

	DNS_ERR_4_FAILED_TO_DELETE_FROM_POWERDNS:
		"Bei der Deinstallation von PowerDNS ist ein Fehler aufgetreten. Bitte wenden Sie sich an unseren Kundendienst, wenn dieses Problem weiterhin besteht.",

	DNS_ERR_5_MULTIPLE_ENTRIES_NOT_ALLOWED:
		"Für einige Datensätze sind mehrere Zeilen mit der gleichen Bezeichnung nicht zulässig, ändern Sie diese.",

	DNS_ERR_6_DOMAIN_1: "",

	DNS_ERR_7_A_1: "Ein A-Eintrag benötigt eine gültige IPv4-Adresse als Wert.",

	DNS_ERR_8_AAAA_1: "Ein AAAA-Eintrag benötigt eine gültige IPv6-Adresse als Wert.",

	DNS_ERR_9_ALIAS_1: "",

	DNS_ERR_10_CAA_1: "",

	DNS_ERR_11_CNAME_1: "Ein CNAME-Eintrag kann kein @ als Bezeichnung haben.",

	DNS_ERR_12_CNAME_2:
		"Ein CNAME-Eintrag benötigt einen gültigen Domainnamen als Wert und muss auf eine .",

	DNS_ERR_13_CNAME_3:
		"Ein CNAME-Eintrag kann nicht mehrere Einträge für dieselbe Bezeichnung enthalten.",

	DNS_ERR_14_CNAME_4:
		"Ein CNAME-Eintrag kann nicht die gleiche Bezeichnung wie ein A- oder AAAA-Eintrag haben.",

	DNS_ERR_15_MX_1:
		"Ein MX-Eintrag benötigt einen gültigen Domainnamen als Wert und muss auf eine .",

	DNS_ERR_16_LABEL_1: "Ungültiges Etikett.",

	DNS_ERR_17_NS_1: "Ein NS-Eintrag kann kein @ als Label haben.",

	DNS_ERR_18_NS_2:
		"Ein NS-Eintrag benötigt einen gültigen Domainnamen als Wert und muss auf eine .",

	DNS_ERR_19_NONE_1: "Ungültiger DNS-Eintragstyp.",

	DNS_ERR_20_PTR_1: "",

	DNS_ERR_21_URI_1: "",

	DNS_ERR_22_SOA_1: "",

	DNS_ERR_23_SPF_1: "",

	DNS_ERR_24_SRV_1: "Ungültige Bezeichnung für SRV-Eintrag.",

	DNS_ERR_25_SRV_2: "Ungültiger Wert für SRV-Eintrag.",

	DNS_ERR_26_TLSA_1: "",

	DNS_ERR_27_TXT_1: "",

	DNS_ERR_28_FAILED_TO_DELETE_DNS_ZONE:
		"Beim Löschen der DNS-Zone der Domain ist ein Problem aufgetreten. Bitte kontaktieren Sie unseren Kundenservice.",

	DNS_ERR_29_DNSSEC_KEY_INVALID_ALGORITHM:
		"Bei der Erstellung des DNSSEC-Schlüssels ist ein Fehler bei unserem Drittanbieter aufgetreten. Bitte kontaktieren Sie unseren Kundenservice.",

	DNS_ERR_30_OXXA_ADD_DNSSEC_ITEMS_FAILED:
		"Bei der Aktivierung von DNSSEC für diese Domain ist ein Fehler bei unserem Drittanbieter aufgetreten. Bitte wenden Sie sich an unser Kundenservice-Team.",

	DNS_ERR_31_OXXA_DELETE_DNSSEC_ITEM_FAILED:
		"Beim Entfernen von DNSSEC für diese Domain ist ein Fehler bei unserem Drittanbieter aufgetreten. Bitte wenden Sie sich an unser Kundenservice-Team.",

	DNS_ERR_32_POWERDNS_ADD_DNSSEC_ITEMS_FAILED:
		"Bei der Aktivierung von DNSSEC für diese Domain ist ein Fehler bei unserem Drittanbieter aufgetreten. Bitte wenden Sie sich an unser Kundenservice-Team.",

	DNS_ERR_33_POWERDNS_READ_DNSSEC_ITEMS_FAILED:
		"Beim Abrufen der DNSSEC-Informationen für diese Domain ist ein Fehler bei unserem Drittanbieter aufgetreten. Bitte wenden Sie sich an unser Kundenservice-Team.",

	DNS_ERR_34_POWERDNS_DELETE_DNSSEC_ITEMS_FAILED:
		"Beim Entfernen von DNSSEC für diese Domain ist ein Fehler bei unserem Drittanbieter aufgetreten. Bitte wenden Sie sich an unser Kundenservice-Team.",

	DNS_ERR_35_POWERDNS_NOT_ALLOWED_TO_READ_ZONE:
		"Dieser Schuldner hat keine Berechtigung zum Lesen oder Schreiben in dieser DNS-Zone. Sollte dies nicht der Fall sein, wenden Sie sich bitte an unseren Kundendienst.",

	DNS_ERR_36_PARSING_DNS_RECORDS_FAILED:
		"Beim Abrufen der DNS-Einträge ist ein Fehler aufgetreten. Bitte kontaktieren Sie unseren Kundendienst, wenn das Problem weiterhin besteht.",

	DNS_ERR_37_SRV_3: "Gewicht und Portnummern müssen zwischen 0 und 65535 liegen.",

	DNS_ERR_38_FAILED_TO_UPDATE_DNS_RECORD_ITEM:
		"Beim Aktualisieren einer DNS-Eintragsregel ist ein Fehler aufgetreten. Bitte wenden Sie sich an unseren Kundendienst, wenn das Problem weiterhin besteht.",

	/* ----------------------------- DOMAIN RELATED ----------------------------- */
	DOMAIN_ERR_1_DOMAIN_NOT_FOUND:
		"Domain nicht gefunden. Bitte überprüfen Sie, ob diese Domain existiert und ob Sie der Besitzer dieser Domain sind",

	DOMAIN_ERR_2_DOMAIN_ALREADY_CANCELLED:
		"Die Domain wurde bereits gekündigt. Sie können eine Domain, die bereits gekündigt wurde, nicht kündigen. Möchten Sie sie kündigen? Dann kontaktieren Sie bitte unseren Kundenservice",

	DOMAIN_ERR_3_DOMAIN_STILL_ACTIVE_OR_AUTORENEW_IS_ON:
		"Die Domain ist noch aktiv und/oder die automatische Erneuerung ist eingeschaltet, bitte deaktivieren Sie zuerst die automatische Erneuerung",

	DOMAIN_ERR_4_CANNOT_REVERSE_ACTION_ON_RENEWAL:
		"Sie können die Kündigung einer Domain nicht rückgängig machen. Möchten Sie sie trotzdem rückgängig machen? Bitte kontaktieren Sie unseren Kundenservice. ",

	DOMAIN_ERR_5_PRODUCT_DOMAIN_NOT_FOUND:
		"Domainerweiterung nicht gefunden. Wenn Sie sicher sind, dass sie existieren sollte, kontaktieren Sie bitte unseren Kundenservice.",

	DOMAIN_ERR_6_PRODUCT_DOMAIN_IN_USE:
		"Eine Produktdomain kann nicht erstellt werden, da sie bereits existiert, bitte verwenden Sie die bereits existierende.",

	DOMAIN_ERR_7_PRODUCT_DOMAIN_UNKNOWN_PRICE_COMMAND:
		"Dieser Befehl wird nicht verwendet, um den Domainerweiterung-Preis zu überprüfen. Bitte kontaktieren Sie den Support oder senden Sie eine Funktionsanfrage, wenn Sie diesen Befehl hinzufügen möchten.",

	DOMAIN_ERR_8_EXTERNAL_PARTY_ERROR:
		"Es ist ein Fehler bei unserem externen Anbieter aufgetreten, der wahrscheinlich auf einen Tippfehler zurückzuführen ist oder der Dienst ist nicht verfügbar.",

	DOMAIN_ERR_9_HOSTFACT_HANDLE_NOT_FOUND:
		"Der Hostfact-Handle wurde nicht gefunden, bitte prüfen Sie, ob er existiert. Wenn ja, wenden Sie sich bitte an einen Entwickler.",

	DOMAIN_ERR_10_FAILED_CREATING_OXXA_IDENTITY:
		"Irgendetwas ist bei der Erstellung einer oxxa-Identität schief gelaufen, wahrscheinlich aufgrund einer Fehleingabe oder falscher Angaben zu den Beziehungsdetails.",

	DOMAIN_ERR_11_FAILED_IMPORTING_DOMAIN:
		"Beim Importieren einer Domain von hostfact ist etwas schief gelaufen. Bitte überprüfen Sie alle Informationen sorgfältig und ob die richtige Relation ausgewählt wurde. Wenn das Problem weiterhin besteht, kontaktieren Sie bitte einen Entwickler",

	DOMAIN_ERR_12_DOMAIN_HAS_NO_DOMAIN_RELATION_DETAILS:
		"Diese Domain hat keine Beziehungsdetails, bitte fügen Sie diese hinzu oder überprüfen Sie, ob die Details korrekt gesetzt sind",

	DOMAIN_ERR_13_NO_SIMILAR_RELATIONS_FOUND:
		"Irgendetwas ist beim Vergleich der Beziehungen schief gelaufen",

	DOMAIN_ERR_14_QUEUE_INVALID_DOMAIN_STATUS:
		"Die ausgewählte Domain hat einen Status, der die von Ihnen gewählte Aktion nicht zulässt. Bitte überprüfen Sie, ob Sie die richtige Domain aktualisieren, oder aktualisieren Sie die Seite für die aktuellen Domainstatus",

	DOMAIN_ERR_15_NS_GROUP_NOT_FOUND: "Die Ns-Gruppe wurde für diese Domain nicht gefunden",

	DOMAIN_ERR_16_DEBTOR_ALREADY_USING_CUSTOM_NS_GROUP:
		"Ihr Konto verwendet bereits eine benutzerdefinierte NS-Gruppe",

	DOMAIN_ERR_17_NS_GROUP_NOT_ON_THIS_DOMAIN:
		"Ns-Gruppe ist keine Option für diese Domain oder nicht verfügbar.",

	DOMAIN_ERR_18_FATAL_ERROR_WHILE_FETCHING_NS_GROUP:
		"Beim Abrufen der NS-Gruppe ist ein schwerwiegender Fehler aufgetreten, bitte versuchen Sie es erneut oder wenden Sie sich an unseren Kundendienst",

	DOMAIN_ERR_19_DOMAIN_NOT_RELATED_TO_ACCOUNT:
		"Die Domain ist nicht mit diesem Konto verbunden. Bitte prüfen Sie, ob Sie im Besitz dieser Domain sind",

	DOMAIN_ERR_20_TLD_DOES_NOT_USER_EPP: "Diese Domainerweiterung unterstützt keine Transfers.",

	DOMAIN_ERR_21_PRODUCT_DOMAIN_LOCKED_GROUP:
		"Sie können keine Produkte aus einer gesperrten Produktgruppe entfernen",

	DOMAIN_ERR_22_PRODUCT_DOMAIN_NOT_PRESENT_IN_GROUP:
		"Dieses Produkt ist nicht in der Gruppe vorhanden, bitte fügen Sie es zuerst hinzu.",

	DOMAIN_ERR_23_PRODUCT_DOMAIN_ALREADY_PRESENT_IN_GROUP:
		"Dieses Produkt ist bereits in der Gruppe vorhanden.",

	DOMAIN_ERR_24_TLD_ACTION_NOT_ENABLED:
		"Es ist ein Problem aufgrund einer nicht autorisierten Aktion einer Domainerweiterung aufgetreten. Bitte wenden Sie sich an unser Kundendienstteam.",

	DOMAIN_ERR_25_DOMAIN_NAME_TOO_SHORT_FOR_EXTENSION:
		"Der Domainname für diese Domainendung ist zu kurz. Erstellen Sie einen Domainnamen mit einer höheren Anzahl von Zeichen.",

	DOMAIN_ERR_26_DOMAIN_NAME_TOO_LONG_FOR_EXTENSION:
		"Der Domainname für diese Domainendung ist zu lang. Bitte erstellen Sie einen Domainnamen mit einer geringeren Anzahl von Zeichen.",

	DOMAIN_ERR_27_EXTENSION_DOES_NOT_ALLOW_NUMERIC_ONLY_DOMAIN_NAME:
		"Diese Domainendung unterstützt keine Domainnamen, die nur aus Zahlen bestehen. Zahlen werden jedoch unterstützt, wenn der Name mindestens einen Buchstaben enthält.",

	DOMAIN_ERR_28_FAILED_UPDATING_OXXA_IDENTITY:
		"Es ist ein Fehler bei unserem Drittanbieter aufgetreten. Bitte kontaktieren Sie unseren Kundendienst.",

	DOMAIN_ERR_29_FAILED_DELETING_OXXA_IDENTITY:
		"Es ist ein Fehler bei unserem Drittanbieter aufgetreten. Bitte kontaktieren Sie unseren Kundendienst.",

	DOMAIN_ERR_30_FAILED_UPDATING_DOMAIN:
		"Bei der Aktualisierung der Domain ist ein Problem mit unserem Drittanbieter aufgetreten. Bitte kontaktieren Sie unseren Kundendienst, wenn dieses Problem weiterhin besteht.",

	DOMAIN_ERR_31_PRODUCT_DOMAIN_REQUIRES_EPP_CODE_FOR_EDIT_DOMAIN:
		"Diese Domain benötigt einen Umzugscode, um die Domain zu bearbeiten.",

	DOMAIN_ERR_32_FAILED_TO_READ_DOMAIN_PURCHASE_INFO:
		"Beim Lesen der Details zu dieser Domain ist ein Fehler aufgetreten. Bitte kontaktieren Sie unseren Kundenservice, wenn dieses Problem weiterhin besteht.",

	DOMAIN_ERR_35_FAILED_PARSING_ADDRESS_FROM_HOSTFACT:
		"Die Adresse aus Hostfact kann nicht in den Straßennamen, die Hausnummer und das Hausnummernsuffix aufgeteilt werden. Bitte kontaktieren Sie die Entwickler",

	DOMAIN_ERR_37_TRANSFER_NOT_AVAILABLE_AT_THE_MOMENT:
		"Die Übertragung eines dieser Domänennamen ist derzeit nicht möglich. Bitte kontaktieren Sie unseren Kundendienst, wenn dieses Problem weiterhin besteht.",
	/* ---------------------------------- BASE ---------------------------------- */
	error_code: "Fehlercode",
	error_msg: "Fehlermeldung",

	/* ------------------------------ ORDER RELATED ----------------------------- */
	ORDER_ERR_1_ORDER_NOT_FOUND: "",

	ORDER_ERR_2_ERROR_DURING_PRICE_CALCULATION:
		"Bei der Berechnung des Preises für ein Produkt in der Bestellung ist ein Fehler aufgetreten. Bitte kontaktieren Sie unseren Kundenservice.",

	/* ------------------------------- PBS RELATED ------------------------------ */
	PBS_ERR_1_NOT_A_RESELLER:
		"Ihr Konto hat keinen Wiederverkäuferstatus, daher können Sie PBS nicht im Wiederverkäufermodus anfordern.",
	PBS_ERR_2_DATASTORE_NAME_NOT_UNIQUE:
		"Sie haben bereits einen Datastore mit demselben Namen. Ihr Datastorename muss einzigartig sein.",
	PBS_ERR_3_FREE_ALREADY_ENABLED:
		"Es ist nicht möglich, mehr als eine kostenlose Version von PBS pro Kunde zu bestellen.",
	PBS_ERR_4_DEBTOR_NOT_ALLOWED_ON_LOCATION:
		"Es ist nicht möglich, einen PBS an dem ausgewählten Standort anzufordern. Bitte wählen Sie einen anderen Standort oder kontaktieren Sie unseren Kundenservice.",
	PBS_ERR_5_ERROR_EMAIL_ADDRESS_REQUIRED:
		"Um Fehlermeldungen zu erhalten, ist eine E-Mail-Adresse erforderlich. Diese kann auf der vorherigen Seite eingestellt werden.",
	PBS_ERR_6_LOCATION_HAS_NO_DEFAULT_NODE:
		"Zurzeit können wir am ausgewählten Standort keinen geeigneten Server finden, auf dem ein neuer PBS installiert werden kann. Bitte kontaktieren Sie unseren Kundenservice, wenn dieses Problem weiterhin besteht.",
	PBS_ERR_7_USER_REGISTRATION_FAILED:
		"Bei der Registrierung eines neuen Benutzers auf der PBS-Website ist ein Fehler aufgetreten. Wenn dieses Problem weiterhin besteht, wenden Sie sich bitte an unseren Kundendienst.",
	PBS_ERR_8_FAILED_TO_CREATE_ZFS_DATASTORE:
		"Beim Erstellen eines neuen ZFS-Datenspeichers ist ein Fehler aufgetreten. Wenn dieses Problem weiterhin besteht, wenden Sie sich bitte an unseren Kundendienst.",
	PBS_ERR_9_FAILED_TO_CREATE_PBS_DATASTORE:
		"Beim Erstellen eines neuen PBS-Datenspeichers ist ein Fehler aufgetreten. Wenn dieses Problem weiterhin besteht, wenden Sie sich bitte an unseren Kundendienst.",
	PBS_ERR_10_FAILED_TO_CREATE_PBS_USER_PERMISSIONS:
		"Bei der Zuweisung von Zugriffsrechten für den Benutzer auf den Datenspeicher ist ein Fehler aufgetreten. Wenn dieses Problem weiterhin besteht, wenden Sie sich bitte an unseren Kundendienst.",
	PBS_ERR_11_NOT_FOUND: "Der ausgewählte PBS wurde nicht gefunden.",
	PBS_ERR_12_LIMIT_LOWER_THEN_CURRENT_USAGE:
		"Das neue Datenspeicherlimit ist niedriger als die aktuelle Nutzung. Erhöhen Sie das Limit, um fortzufahren.",
	PBS_ERR_13_RESELLER_RELATION_NOT_UPDATABLE:
		"Sie können die Beziehung eines PBS nicht ändern, wenn es für einen Kunden eingesetzt wird (Wiederverkäufer-Modus).",
	PBS_ERR_14_CANCELLATION_ALREADY_PENDING: "Dieser Dienst (PBS) wurde bereits eingestellt.",
	PBS_ERR_15_CANCELLATION_NOT_PENDING:
		"Der Dienst wurde nicht gekündigt, daher ist es nicht möglich, die Kündigung rückgängig zu machen.",
	PBS_ERR_16_LOCATION_NOT_FOUND: "Der angegebene PBS-Standort konnte nicht gefunden werden.",
	PBS_ERR_17_NODE_NOT_FOUND:
		"Derzeit können wir keinen Server am ausgewählten Standort finden. Bitte kontaktieren Sie unseren Kundenservice, wenn dieses Problem weiterhin besteht.",
	PBS_ERR_18_FAILED_TO_CREATE_PBS_API_TOKEN:
		"Derzeit kann kein neuer API-Token auf dem PBS-Knoten erstellt werden. Bitte kontaktieren Sie unseren Kundensupport, wenn dieses Problem weiterhin besteht.",
	PBS_ERR_19_FAILED_TO_CREATE_PBS_API_TOKEN_PERMISSIONS:
		"Derzeit können keine PBS-Berechtigungen zum API-Token auf dem PBS-Knoten hinzugefügt werden. Bitte kontaktieren Sie unseren Kundensupport, wenn dieses Problem weiterhin besteht.",

	/* -------------------------------- PBS SYNC -------------------------------- */
	PBS_SYNC_ERR_1_SYNC_FAILED_CREATE_REMOTE:
		"Der Remote-Host konnte auf dem Ziel-PBS-Knoten nicht erstellt werden. Bitte kontaktieren Sie unseren Kundensupport, wenn dieses Problem weiterhin besteht.",
	PBS_SYNC_ERR_2_SYNC_FAILED_CREATE_SYNC_JOB:
		"Ein Sync-Job konnte auf dem Ziel-PBS-Knoten nicht erstellt werden. Bitte kontaktieren Sie unseren Kundensupport, wenn dieses Problem weiterhin besteht.",
	PBS_SYNC_ERR_3_SYNC_FAILED_CREATE_SYNC_IN_DATABASE:
		"Der Remote-Host konnte in unserer Datenbank nicht erstellt werden. Bitte kontaktieren Sie unseren Kundensupport, wenn dieses Problem weiterhin besteht.",
	PBS_SYNC_ERR_4_SYNC_FAILED_CREATE_FATAL_ERROR:
		"Derzeit kann kein PBS-Sync erstellt werden. Bitte kontaktieren Sie unseren Kundensupport, wenn dieses Problem weiterhin besteht.",
	PBS_SYNC_ERR_5_COULD_NOT_READ_REMOTE:
		"Der Remote-PBS kann derzeit nicht von Proxmox gelesen werden.",
	PBS_SYNC_ERR_6_COULD_NOT_READ_SYNC_JOB:
		"Der Sync-Job kann derzeit nicht von Proxmox gelesen werden.",
	PBS_SYNC_ERR_7_COULD_NOT_READ_SYNC_RECORD_FROM_DATABASE:
		"Der Sync-Job kann derzeit nicht aus der Datenbank gelesen werden.",
	PBS_SYNC_ERR_8_SYNC_READ_SYNC_FATAL_ERROR:
		"Beim Abrufen der Sync-Informationen ist ein Fehler aufgetreten. Bitte kontaktieren Sie unseren Kundensupport, wenn dieses Problem weiterhin besteht.",
	PBS_SYNC_ERR_9_SYNC_FAILED_UPDATE_REMOTE:
		"Der Remote-Host konnte derzeit in Proxmox nicht aktualisiert werden.",
	PBS_SYNC_ERR_10_SYNC_FAILED_UPDATE_SYNC_JOB:
		"Der Sync-Job konnte derzeit in Proxmox nicht aktualisiert werden.",
	PBS_SYNC_ERR_11_SYNC_UPDATE_SYNC_IN_DATABASE:
		"Der Sync-Job konnte derzeit nicht in der Datenbank aktualisiert werden.",
	PBS_SYNC_ERR_12_SYNC_UPDATE_FATAL_ERROR:
		"Der PBS-Sync konnte derzeit nicht aktualisiert werden. Bitte kontaktieren Sie unseren Kundensupport, wenn dieses Problem weiterhin besteht.",
	PBS_SYNC_ERR_13_DELETE_REMOTE_ERROR: "Der Remote-Host konnte nicht aus Proxmox gelöscht werden.",
	PBS_SYNC_ERR_14_DELETE_SYNC_JOB_ERROR: "Der Sync-Job konnte nicht aus Proxmox gelöscht werden.",
	PBS_SYNC_ERR_15_DELETE_SYNC_FROM_DATABASE_ERROR:
		"Der Sync-Job konnte nicht aus der Datenbank gelöscht werden.",
	PBS_SYNC_ERR_16_DELETE_SYNC_FATAL_ERROR:
		"Die Sync-Informationen konnten nicht gelöscht werden. Bitte kontaktieren Sie unseren Kundensupport, wenn dieses Problem weiterhin besteht.",
	PBS_SYNC_ERR_17_REMOTE_HOST_NAME_NOT_PROVIDED_OR_INVALID:
		"Der Name des Remote-Hosts wurde nicht angegeben oder ist ungültig.",
	PBS_SYNC_ERR_18_REMOTE_HOST_PORT_NOT_PROVIDED_OR_INVALID:
		"Der Port des Remote-Hosts wurde nicht angegeben oder ist ungültig.",
	PBS_SYNC_ERR_19_NO_SOURCE_PROVIDED_OR_INVALID:
		"Keine Quelle angegeben. Ein Sync-Job kann ohne Quelle nicht erstellt werden.",
	PBS_SYNC_ERR_20_REMOTE_API_USER_OR_TOKEN_MISSING_OR_INVALID:
		"Der API-Benutzer oder Token fehlt oder ist ungültig.",
	PBS_SYNC_ERR_21_REMOTE_FINGERPRINT_REQUIRED_OR_INVALID:
		"Der Fingerabdruck ist erforderlich, wenn der Host ein selbstsigniertes Zertifikat verwendet.",
	PBS_SYNC_ERR_22_SYNC_PBS_ID_NOT_PROVIDED:
		"Die PBS-ID wurde nicht angegeben. Diese ist erforderlich, wenn der Quell-PBS von Tuxis stammt.",
	PBS_SYNC_ERR_23_NO_SCHEDULE_PROVIDED_OR_INVALID:
		"Kein Synchronisierungsintervall angegeben oder das Intervall ist ungültig.",
	PBS_SYNC_ERR_24_COULD_NOT_ESTABLISH_PAYLOAD:
		"Die Payload konnte nicht erstellt werden. Bitte kontaktieren Sie unseren Kundensupport, wenn dieses Problem weiterhin besteht.",
	PBS_SYNC_ERR_25_INVALID_FINGERPRINT:
		"Der angegebene Fingerabdruck ist ungültig. Bitte überprüfen Sie Ihre Eingabe.",
	PBS_SYNC_ERR_26_PUSH_METHOD_NOT_SUPPORTED_IN_THIS_PORTAL_VERSION:
		"Die Push-Methode wird in dieser Version des Portals nicht unterstützt.",
	PBS_SYNC_ERR_27_REMOTE_TEST_FAILED:
		"Der Verbindungstest mit dem Remote-Host ist fehlgeschlagen. Bitte überprüfen Sie Ihre Eingaben.",
	PBS_SYNC_ERR_28_REMOTE_FETCH_DATASTORE_FAILED:
		"Der Datenspeicher konnte vom Remote-Host nicht gelesen werden. Bitte überprüfen Sie, ob der Name korrekt ist und auf dem angegebenen Remote existiert.",

	/* -------------------------- PRODUCT GROUP RELATED ------------------------- */
	PRODUCT_GROUP_ERR_1_PRODUCT_GROUP_NOT_FOUND: "Produktgruppe nicht gefunden.",

	/* ---------------------------- RELATION RELATED ---------------------------- */

	RELATION_ERR_1_RELATION_NOT_FOUND: "Beziehung nicht gefunden.",

	RELATION_ERR_2_RELATION_DETAILS_NOT_FOUND:
		"Beziehungsdetails wurden bei dieser Beziehung nicht gefunden.",

	RELATION_ERR_3_RELATION_CANT_BE_DELETED_HAS_DOMAINS_LINKED:
		"Die Beziehung kann nicht entfernt werden, da sie mit Domain verbunden ist.",

	RELATION_ERR_4_RELATION_CANT_BE_DELETED_HAS_ITEMS_LINKED:
		"Die Beziehung kann nicht gelöscht werden, da ihr Elemente zugeordnet sind.",

	RELATION_ERR_5_CANNOT_UPDATE_RELATION:
		"Die Beziehung kann nicht aktualisiert werden. Überprüfen Sie Ihre Eingabe oder wenden Sie sich an einen unserer Support-Mitarbeiter.",

	RELATION_ERR_6_CANNOT_CREATE_RELATION:
		"Die Beziehung kann nicht erstellt werden. Überprüfen Sie Ihre Eingaben oder kontaktieren Sie einen unserer Support-Mitarbeiter.",

	RELATION_ERR_7_RELATION_DOMAIN_DETAILS_ALREADY_EXIST:
		"Es wurde versucht, neue Domainbeziehungsdaten für diese Beziehung zu erstellen, aber die Daten sind bereits vorhanden. Bitte wenden Sie sich an unseren Kundendienst, wenn das Problem weiterhin besteht.",

	RELATION_ERR_8_COMPANY_COC_NUMBER_REQUIRED:
		'Die "Handelsregisternummer" wird für eine der verlinkten Domains benötigt. Bitte füllen Sie dieses Feld aus und speichern Sie die Domaindaten für diese Beziehung erneut.',

	RELATION_ERR_9_COMPANY_VAT_NUMBER_REQUIRED:
		'Die "USt-IdNr" wird für eine der verlinkten Domains benötigt. Bitte füllen Sie dieses Feld aus und speichern Sie die Domaindaten für diese Beziehung erneut.',

	RELATION_ERR_10_COMPANY_TRADEMARK_COUNTRY_REQUIRED:
		'Die "Markenland" wird für eine der verlinkten Domains benötigt. Bitte füllen Sie dieses Feld aus und speichern Sie die Domaindaten für diese Beziehung erneut.',

	RELATION_ERR_11_COMPANY_TRADEMARK_NAME_REQUIRED:
		'Die "Markenname" wird für eine der verlinkten Domains benötigt. Bitte füllen Sie dieses Feld aus und speichern Sie die Domaindaten für diese Beziehung erneut.',

	RELATION_ERR_12_COMPANY_TRADEMARK_NUMBER_REQUIRED:
		'Die "Markennummer" wird für eine der verlinkten Domains benötigt. Bitte füllen Sie dieses Feld aus und speichern Sie die Domaindaten für diese Beziehung erneut.',

	RELATION_ERR_13_PERSON_ID_NUMBER_REQUIRED:
		'Die "Nummer identitätsbeweis" wird für eine der verlinkten Domains benötigt. Bitte füllen Sie dieses Feld aus und speichern Sie die Domaindaten für diese Beziehung erneut.',

	RELATION_ERR_14_PERSON_ID_ISSUE_DATE_REQUIRED:
		'Die "Ausgabedatum identitätsbeweis" wird für eine der verlinkten Domains benötigt. Bitte füllen Sie dieses Feld aus und speichern Sie die Domaindaten für diese Beziehung erneut.',

	RELATION_ERR_15_PERSON_ID_ISSUER_REQUIRED:
		'Die "Ausstellende Behörde identitätsbeweis" wird für eine der verlinkten Domains benötigt. Bitte füllen Sie dieses Feld aus und speichern Sie die Domaindaten für diese Beziehung erneut.',

	RELATION_ERR_16_PERSON_BIRTH_DATE_REQUIRED:
		'Die "Datum der Geburt" wird für eine der verlinkten Domains benötigt. Bitte füllen Sie dieses Feld aus und speichern Sie die Domaindaten für diese Beziehung erneut.',

	RELATION_ERR_17_COUNTRY_OF_BIRTH_REQUIRED:
		'Die "Land der Geburt" wird für eine der verlinkten Domains benötigt. Bitte füllen Sie dieses Feld aus und speichern Sie die Domaindaten für diese Beziehung erneut.',

	RELATION_ERR_18_CITY_OF_BIRTH_REQUIRED:
		'Die "Ort der Geburt" wird für eine der verlinkten Domains benötigt. Bitte füllen Sie dieses Feld aus und speichern Sie die Domaindaten für diese Beziehung erneut.',

	RELATION_ERR_19_GIVEN_NAME_REQUIRED:
		'Die "Vorname" und "Nachname wird für eine der verlinkten Domains benötigt. Bitte füllen Sie dieses Feld aus und speichern Sie die Domaindaten für diese Beziehung erneut.',

	RELATION_ERR_20_ZIP_CODE_REQUIRED:
		'Die "Postleitzahl" wird für eine der verlinkten Domains benötigt. Bitte füllen Sie dieses Feld aus und speichern Sie die Domaindaten für diese Beziehung erneut.',

	RELATION_ERR_21_COMPANY_NAME_REQUIRED:
		'Die "Firmenname" wird für eine der verlinkten Domains benötigt. Bitte füllen Sie dieses Feld aus und speichern Sie die Domaindaten für diese Beziehung erneut.',

	/* ------------------------------ USER RELATED ------------------------------ */
	USER_ERR_1_NOT_ALLOWED_AS_NON_SUPERUSER: "Sie sind nicht berechtigt, diese Aktion durchzuführen.",

	USER_ERR_2_USER_NOT_FOUND:
		"Der Benutzer wurde nicht gefunden. Sollte dies nicht der Fall sein, wenden Sie sich bitte an unseren Kundenservice.",

	USER_ERR_3_UPDATE_SEEN_HOMEPAGE_TUTORIAL_FAILED:
		"Bei der Aktualisierung des Tutorials für die Homepage ist ein Fehler aufgetreten.",

	USER_ERR_7_DUPLICATE_SSH_KEY:
		"Der von Ihnen eingegebene öffentliche SSH-Schlüssel ist in Ihrem Konto bereits vorhanden.",
	/* ------------------------------- VPS RELATED ------------------------------ */
	VPS_ERR_1_UNKNOWN_DATACENTER:
		"Das ausgewählte Rechenzentrum kann nicht für die Bereitstellung neuer VPS ausgewählt werden.",
	VPS_ERR_2_TEMPLATE_NOT_FOUND:
		"Das von Ihnen ausgewählte Betriebssystem oder Template konnte auf unserem Server nicht gefunden werden.",
	VPS_ERR_3_TEMPLATE_BACKUP_NOT_FOUND:
		"Das von Ihnen ausgewählte Betriebssystem oder Template hat kein Backup auf unserem Server. Daher ist es derzeit nicht möglich, den VPS bereitzustellen.",
	VPS_ERR_4_TEMPLATE_CONFIG_NOT_FOUND:
		"Derzeit können wir die Konfiguration des von Ihnen ausgewählten Betriebssystems oder Templates nicht abrufen.",
	VPS_ERR_5_INSUFFICIENT_CORES:
		"Die von Ihnen gewählte Konfiguration hat weniger CPU-Kerne als vom ausgewählten Betriebssystem oder Template erforderlich.",
	VPS_ERR_6_TOO_MANY_CORES:
		"Die von Ihnen gewählte Konfiguration hat mehr CPU-Kerne als gemäß den zulässigen Grenzen erlaubt.",
	VPS_ERR_7_INSUFFICIENT_MEMORY:
		"Die von Ihnen gewählte Konfiguration hat weniger Speicher als vom ausgewählten Betriebssystem oder Template erforderlich.",
	VPS_ERR_8_TOO_MUCH_MEMORY:
		"Die von Ihnen gewählte Konfiguration hat mehr Speicher als gemäß den zulässigen Grenzen erlaubt.",
	VPS_ERR_9_INSUFFICIENT_STORAGE:
		"Die von Ihnen gewählte Konfiguration hat weniger Speicherplatz als vom ausgewählten Betriebssystem oder Template erforderlich.",
	VPS_ERR_10_TOO_MUCH_STORAGE:
		"Die von Ihnen gewählte Konfiguration hat mehr Speicherplatz als gemäß den zulässigen Grenzen erlaubt.",
	VPS_ERR_11_PUBLIC_NETWORK_REQUIRED:
		"Eine Internetverbindung ist erforderlich, wenn kein privates Netzwerk verfügbar ist.",
	VPS_ERR_12_PRIVATE_NETWORK_EXISTS:
		"Ein privates Netzwerk mit dem angegebenen Namen existiert bereits.",
	VPS_ERR_13_DATACENTER_NODES_UNAVAILABLE:
		"Es ist derzeit nicht möglich, Ihren VPS in unserem Rechenzentrum bereitzustellen. Sollte das Problem weiterhin bestehen, wenden Sie sich bitte an unseren Support.",
	VPS_ERR_14_CANNOT_SHRINK_STORAGE:
		"Ihr VPS kann nicht aktualisiert werden, da die aktuelle Festplattengröße kleiner ist als die erforderliche Größe. Es ist nicht möglich, die Festplatte zu verkleinern.",
	VPS_ERR_15_CANNOT_DOWNGRADE_SNAPSHOTS:
		"Ihr VPS kann nicht aktualisiert werden, da Sie versuchen, die Anzahl der Snapshots zu verringern, während noch aktive Snapshots vorhanden sind. Entfernen Sie diese Snapshots, bevor Sie mit dem Downgrade fortfahren.",
	VPS_ERR_16_QEMU_ALREADY_RUNNING:
		"Der VPS läuft derzeit bereits. Es kann einige Sekunden dauern, bis dies sichtbar ist.",
	VPS_ERR_17_QEMU_NOT_RUNNING:
		"Der VPS ist derzeit bereits ausgeschaltet. Es kann einige Sekunden dauern, bis dies sichtbar ist.",
	VPS_ERR_18_QEMU_NOT_FOUND: "Der VPS wurde nicht gefunden.",
	VPS_ERR_19_INVALID_SNAPSHOT_NAME:
		"Ungültiger Snapshot-Name: Ein Snapshot mit demselben Namen existiert bereits.",
	VPS_ERR_20_INSUFFICIENT_SNAPSHOTS:
		"Es sind nicht genügend Snapshots verfügbar, um einen neuen bereitzustellen. Erhöhen Sie die Anzahl der verfügbaren Snapshots für den VPS und versuchen Sie es erneut.",
	VPS_ERR_21_SNAPSHOT_NOT_FOUND:
		"Ihr Snapshot kann nicht geändert oder gelöscht werden, da er nicht gefunden werden konnte.",
	VPS_ERR_22_PRIVATE_NETWORK_NOT_FOUND: "Das angeforderte private Netzwerk wurde nicht gefunden.",
	VPS_ERR_23_SNAPSHOT_EXPIRATION_DATE_INVALID:
		"Beim Lesen der Schnappschüsse ist ein Fehler aufgetreten. Bitte wenden Sie sich an unseren Kundendienst, wenn dieses Problem weiterhin besteht.",
};

export default error_codes;
